module.exports = __webpack_public_path__ + "static/mare_low-bd5ca16dd6ea4e6e61f18ac82a95abb8.mp4";